var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStealthOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icStealthOrange") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.956862745   0 0 0 0 0.68627451   0 0 0 0 0.00392156863  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Premium-upgrade",
    transform: "translate(-9.000000, -921.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 706.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icStealthOrange",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "incognito",
    transform: "translate(9.000000, 16.000000)",
    fill: "#F4AF01",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7655374,0.153870695 C30.0145633,-0.158628506 29.1561655,0.0142226521 28.585863,0.587463588 C27.9559826,1.21722198 27.1718046,2.00139998 23.9999347,2.00139998 C21.143502,2.00139998 18.9892075,3.70049164 17.4159715,4.94059247 C16.9726126,5.29020158 16.3280843,5.79801228 16.0771069,5.95719187 C15.8261316,5.77848153 15.4110926,5.37027937 15.1200774,5.0841481 C13.8700806,3.85673324 11.9814054,2.00139598 8.99997301,2.00139598 C5.70702142,2.00139598 3.93944594,1.11284825 3.41404728,0.587459588 C2.83983075,0.0142190521 1.98045694,-0.158632506 1.23437285,0.153866695 C0.487304755,0.463435905 0,1.19280404 0,2.00139598 C0,7.60344167 0.887693732,15.2474621 8.56443812,16.9543578 C11.6943101,17.649546 12.8290672,18.4805999 13.5790653,19.0312525 C14.1679318,19.4628914 14.9013279,20 15.9999591,20 C17.0985883,20 17.8319864,19.4619154 18.4208529,19.0302765 C19.170851,18.4805959 20.3056141,17.648566 23.4345201,16.9533818 C31.1122405,15.2484301 31.9999183,7.60342567 31.9999183,2.00139998 C31.9999183,1.19280804 31.5126155,0.463439905 30.7655454,0.153870695 L30.7655374,0.153870695 Z M5.99999467,8.12687033 C5.99999467,8.12687033 10.558589,7.41886414 12.6666036,9.34512922 C13.9999742,10.5633861 13.9999742,11.781523 13.9999742,12.9997877 C5.99999467,12.9997877 5.99999467,8.12687233 5.99999467,8.12687233 L5.99999467,8.12687033 Z M17.999964,12.9997857 C17.999964,11.781519 17.999964,10.5633841 19.3333406,9.34512722 C21.4413752,7.41886214 25.9999436,8.12686833 25.9999436,8.12686833 C25.9999436,8.12686833 25.9999436,12.9997857 17.999964,12.9997857 L17.999964,12.9997857 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStealthOrange);
export default __webpack_public_path__ + "static/media/icStealthOrange.cb4fcb8653538c68e51ae9dc6bf64b8b.svg";
export { ForwardRef as ReactComponent };